import { render, staticRenderFns } from "./item-box.vue?vue&type=template&id=dfe96790&scoped=true&"
import script from "./item-box.vue?vue&type=script&lang=js&"
export * from "./item-box.vue?vue&type=script&lang=js&"
import style0 from "./item-box.vue?vue&type=style&index=0&id=dfe96790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe96790",
  null
  
)

export default component.exports